window.c24DomReady(function () {
    const apiBase = window.location.hostname === 'local.cms.vz.check24-test.de' ? 'http://localhost:8091' : 'https://api.vz' + window.c24LpDomain;
    const urlParams = window.location.hostname === 'local.cms.vz.check24-test.de' ? '?c24session=' + '' : '';

    function displayMessage(message, textColor, backgroundColor) {
        const existingMessage = document.getElementById('vplusErrorMessage');
        if (existingMessage) {
            existingMessage.remove();
        }

        const errorMessage = document.createElement('div');
        errorMessage.id = 'vplusErrorMessage';
        errorMessage.textContent = message;
        errorMessage.style.color = textColor;
        errorMessage.style.position = 'fixed';
        errorMessage.style.top = '50%';
        errorMessage.style.left = '50%';
        errorMessage.style.transform = 'translate(-50%, -50%)';
        errorMessage.style.backgroundColor = backgroundColor;
        errorMessage.style.padding = '20px 40px';
        errorMessage.style.borderRadius = '12px';
        errorMessage.style.boxShadow = '0px 15px 30px rgba(0, 0, 0, 0.1), 0px 5px 15px rgba(0, 0, 0, 0.1)';
        errorMessage.style.fontSize = '16px';
        errorMessage.style.textAlign = 'center';
        errorMessage.style.zIndex = '1000';
        document.body.appendChild(errorMessage);

        // Auto-remove message after 3 seconds
        setTimeout(() => {
            errorMessage.remove();
        }, 3000);
    }

    const bonusProgramArea = document.querySelector('.mod24BonusProgramBlockWrapper');
    if (!bonusProgramArea) {
        return;
    }

    if (window.c24LpIsExported && !bonusProgramArea.classList.contains('is-logged-in')) {
        if (window.c24LpIsApp) {
            let loginUrl = new URL(window.location.href);
            loginUrl.searchParams.set('loggedin', '1');

            const loginUrlString = loginUrl.toString().replace('https:', 'c24-app-login:');

            document.location.href = loginUrlString;
        } else {
            window.c24OpenLoginLayer();
        }

        return;
    }

    if (
        !bonusProgramArea.classList.contains('is-member')
    ) {
        return;
    }

    if (!bonusProgramArea.classList.contains('has-vouchers') && bonusProgramArea.classList.contains('show-activation')) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const vtoken = params.get('vtoken');

        if (vtoken) {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', apiBase + '/public/vplus/v1/get-possible-voucher-plans' + urlParams, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.withCredentials = true;
            xhr.timeout = 60 * 1000;

            xhr.onreadystatechange = function () {

                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {

                        const vouchers = JSON.parse(xhr.responseText).cs_plans;

                        const template = bonusProgramArea.querySelector('.ticketsList.template');
                        const ticket = template.querySelector('.ticket');
                        for (const voucher of vouchers) {
                            const ticketClone = ticket.cloneNode(true);
                            ticketClone.querySelector('.ticketValue').textContent = Math.floor(parseFloat(voucher.csplan_product_value)) + ' €';
                            ticketClone.querySelector('.ticketMainTextValue').textContent = voucher.csplan_product_name + ' Gutschein';
                            template.appendChild(ticketClone);
                        }
                        ticket.remove();
                        template.classList.remove('hidden');

                        const loadingCard = bonusProgramArea.querySelector('.card.loading');
                        loadingCard.classList.add('hidden');
                    } else {
                        displayMessage('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.', '#ff3b30', '#f8d7da');
                    }
                }
            };

            xhr.send(JSON.stringify({
                vtoken: vtoken,
            }));

            const activationButtons = document.querySelectorAll('.j24VplusActivateVoucherButton');
            if (activationButtons) {
                activationButtons.forEach(function (activationButton) {
                    activationButton.addEventListener('click', function () {

                        activationButtons.forEach(function (button) {
                            button.disabled = true;
                            button.style.backgroundColor = '#d3d3d3';
                        });

                        const template = bonusProgramArea.querySelector('.ticketsList.template');
                        template.classList.add('hidden');

                        const loadingCard = bonusProgramArea.querySelector('.card.loading');
                        loadingCard.classList.remove('hidden');

                        const xhr = new XMLHttpRequest();
                        xhr.open('POST', apiBase + '/public/vplus/v1/activate-voucher-plans' + urlParams, true);
                        xhr.setRequestHeader('Content-Type', 'application/json');
                        xhr.withCredentials = true;
                        xhr.timeout = 60 * 1000;

                        xhr.onreadystatechange = function () {

                            if (xhr.readyState === XMLHttpRequest.DONE) {
                                if (xhr.status === 200) {
                                    document.location.href = document.location.pathname + '?vactivated=true';
                                } else {
                                    displayMessage('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.', '#ff3b30', '#f8d7da');
                                }
                            }
                        };

                        xhr.send(JSON.stringify({
                            vtoken: vtoken,
                        }));
                    });
                });
            }
        }
    }

    const cancelButton = document.querySelector('.cancelInsurancePlusMembership');
    if (cancelButton) {
        cancelButton.addEventListener('click', function () {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', apiBase + '/public/vplus/v1/cancel' + urlParams, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.withCredentials = true;
            xhr.timeout = 60 * 1000;

            xhr.onreadystatechange = function () {

                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {

                        window.location.href = cancelButton.getAttribute('data-redirect-url');

                    } else {
                        displayMessage('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.', '#ff3b30', '#f8d7da');
                    }
                }
            };

            xhr.send(JSON.stringify({
                confirm: 'yes',
            }));
        });
    }

    const tooltips = document.querySelectorAll('.c24Tooltip');
    if (tooltips) {
        tooltips.forEach(function (tooltip) {
            tooltip.addEventListener('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
        });
    }

    const moreButton = document.querySelector('.moreItems .moreText');
    if (moreButton) {

        const selector = window.c24LpIsMobile ? '.pointsList .pointsListItem:nth-child(n+4)' : '.pointsList .pointsListItem:nth-child(n+5)';

        moreButton.addEventListener('click', function () {
            const hiddenItems = document.querySelectorAll(selector);
            hiddenItems.forEach(function (item) {
                if (item.style.display === 'none' || item.style.display === '') {
                    item.style.display = 'grid';
                    moreButton.textContent = 'weniger';
                    moreButton.classList.add('open');
                } else {
                    item.style.display = 'none';
                    moreButton.textContent = 'mehr';
                    moreButton.classList.remove('open');
                }

            });
        });
    }
});
